import { EPISODE_LIST } from '../../app/state/constants';

function ListItemCount({ listType, count = 0 }) {
    return `${count} ${listType === EPISODE_LIST ? 'episode' : 'podcast'}${count === 1 ? '' : 's'}`;
}

export default ListItemCount;
